export default defineNuxtPlugin((_nuxtApp) => {
  return {
    provide: {
      getPathFor: (path: string, urlBase: string) => {
        return `/${urlBase}/${path}`.replaceAll('//', '/').replaceAll('//', '/')
      },
    },
  }
})
